import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

/**
 * F26 — Check se l'utente corrente è admin DryConfig (riga in public.app_admins).
 * Usato per gate la pagina /admin e la voce sidebar.
 */
export function useIsAppAdmin() {
  const { user } = useAuth();
  const query = useQuery<boolean>({
    queryKey: ['is_app_admin', user?.id],
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      if (!user?.id) return false;
      const { data, error } = await supabase
        .from('app_admins')
        .select('user_id')
        .eq('user_id', user.id)
        .maybeSingle();
      if (error) {
        console.warn('[useIsAppAdmin] errore fetch:', error);
        return false;
      }
      return !!data;
    },
  });
  return {
    isAdmin: query.data ?? false,
    isLoading: query.isLoading,
  };
}
